import _ from 'lodash';
import { DiscountEligibility } from '../../constants';

const encodeStateroomsObj = (staterooms) => {
  if (staterooms) {
    return staterooms.map((stateroom) => _.omitBy(stateroom, (stateroomValue, property) => {
      if (stateroom.discounts && !stateroom.discounts.includes(DiscountEligibility.PAST_PASSENGER)
      && (property === 'passengerFirstName' || property === 'passengerMiddleName' || property === 'passengerLastName'
      || property === 'pastPassengerNumbers')) return true;

      if (stateroom.discounts && !stateroom.discounts.includes(DiscountEligibility.OCCUPATION)
      && property === 'passengerOccupation') return true;

      return (typeof stateroomValue === 'string' && !stateroomValue) || (typeof stateroomValue === 'number' && stateroomValue === 0) || (typeof stateroomValue === 'object' && (stateroomValue || {}).length === 0);
    }));
  }
  return staterooms;
};

export default encodeStateroomsObj;
